<template>
  <div class="products-wrap">
    <div v-for="category in categories" :key="category.id">
      <template v-if="category.products && category.products.length">
        <div class="category-title">{{ category.name[selectedLanguage.key] }}</div>
        <div class="category-title-border"></div>
      
        <div class="row products-list main-container">
          <!-- place item-->
          <div v-for="product in category.products" :key="product.id" class="product">
            <div class="product__inner">
              <div class="product__img"
                v-bind:style="{ backgroundImage: 'url(' + product.images[0] + ')' }">
                <div class="product__price">AED {{ product.price }}</div>
              </div>
              <div class="product__cont">
                <div class="product__title">{{ product.name[selectedLanguage.key] }}</div>
                <div class="product__text">{{ product.description[selectedLanguage.key] }}</div>
                
                <div class="product__add-group" v-if="!!cartProducts[product.id] && clientSettings.online_order">
                  <button type="submit" @click="setCartProduct(product)" class="product__add-btn" name="type" value="plus">
                    <span></span>
                    <span></span>
                  </button>
                  
                  <div class="product__add-num">{{ cartProducts[product.id].count }}</div>
                  
                  <button type="submit" @click="removeCartProduct(product)" class="product__add-btn" name="type" value="minus">
                    <span></span>
                  </button>
                </div>
                
                <div class="product__add-first" v-else-if="clientSettings.online_order">
                  <button type="submit" @click="setCartProduct(product)" class="product__add-btn" name="type" value="plus">
                    <span></span>
                    <span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props: {
      categories: {
        type: Array,
        default: () => ({})
      }
    },
    computed: {
      ...mapState('settings', ['selectedLanguage', 'clientSettings']),
      ...mapState('cart', ['cartProducts']),
    },
    methods: {
      ...mapActions('cart', ['setCartProduct', 'removeCartProduct'])
    },
    created() {
      setTimeout(() => {
        window.scrollTo(0, getOffset(document.getElementsByClassName('content')[0]).top);
      })
    }
  }

function getOffset( el ) {
    var _x = 0;
    var _y = 0;
    while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
    }
    return { top: _y, left: _x };
}
</script>
